import { payStatistcs } from '@/api/statistics';
import { getWxConfig } from '@/api/wx';
import APP_CONFIG, { WX_CONFIG } from '@/APP_CONFIG';
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useUserStore } from '@/pinia/user';
import { useToast } from './useToast';
import wx from 'weixin-js-sdk';

export function useWxConfig() {
  redirectUrl();
  function initWxConfig() {
    if (APP_CONFIG.ENV != 'production') return;
    getWxConfig().then((res) => {
      const config = res.data;
      wx.config({
        debug: false,
        appId: WX_CONFIG.appId,
        timestamp: config.timestamp,
        nonceStr: config.noncestr,
        signature: config.signature,
        jsApiList: ['checkJsApi', 'chooseWXPay', 'onMenuShareTimeline', 'onMenuShareAppMessage'],
        beta: false,
      });
    });
    wx.error = (e) => {
      console.log('wx error');
      console.log(e);
    };
    wx.ready(() => {});
  }
  return {
    initWxConfig,
  };
}
export function useWxPay() {
  const route = useRoute();
  const jid = computed(() => route.query.jid);
  const path = computed(() => route.query.path);
  const user = useUserStore();
  const openId = computed(() => user.openid);
  const Toast = useToast();
  function onCancelPay(msg = '您已取消支付,是否重新支付') {
    Toast.comfirm({
      title: msg,
      ok: () => {
        handleWxPay();
      },
    });
  }
  const router = useRouter();
  function handleWxPay() {
    payStatistcs(openId.value, jid.value).then((res) => {
      if (APP_CONFIG.ENV == 'production') {
        const config = res.data;
        wx.checkJsApi({
          jsApiList: ['chooseWXPay'],
          success: function () {
            const payData = {
              appId: WX_CONFIG.appId,
              timestamp: config.timeStamp,
              nonceStr: config.nonceStr,
              package: 'prepay_id=' + config.package,
              signType: config.signType,
              paySign: config.paySign,
            };
            wx.chooseWXPay({
              ...payData,
              success: function (res) {
                // 支付成功后的回调函数
                if (res.errMsg == 'chooseWXPay:ok') {
                  // 更新支付信息！
                  user.getPayInfo();
                  router.replace({
                    path: '/eva/pay_success',
                    query: {
                      jid: jid.value,
                      path: path.value,
                    },
                  });
                  //支付成功
                } else {
                  onCancelPay('支付失败!是否重新支付?');
                  console.warn('支付失败');
                }
              },
              cancel: function (err) {
                console.log(err);
                //支付取消
                console.warn('用户取消支付');
                onCancelPay();
              },
            });
          },
        });
      }
    });
  }

  return {
    handleWxPay,
  };
}
/**
 *
 * @desc 为了微信授权返回的地址重定向 到 合法的hash地址
 * @eg https://zc.innpst.com/?code=xxx&state=STATE#/change-psd?f=wx&d=2 => https://zc.innpst.com/#/change-psd?code=xxx&state=STATE&f=wx&d=2
 */
function redirectUrl() {
  let url = '';
  if (APP_CONFIG.ENV == 'production') {
    url = window.location.href;
  } else {
    url = `https://zc.innpst.com/view?rid=79154&t=1&f=wx`;
  }
  // localStorage.setItem(Date.now() + '==base', url);
  const codes = url.match(/https:\/\/zc.innpst.com\/(\S*)#/);
  let query: Recordable = {};
  if (codes?.[1] != '' && codes?.[1] != null) {
    const wxQuery = codes[1].split('?');
    query = { ...getQuery(wxQuery[1]) };
    const _url = url.replaceAll(codes[1], '');
    const [baseUrl, baseQuery] = _url.split('?');
    if (baseQuery) {
      query = { ...query, ...getQuery(baseQuery) };
    }
    const resultUrl = baseUrl + (wxQuery[0] || '') + formatQuery(query);
    if (APP_CONFIG.ENV != 'production') return;
    setTimeout(() => {
      location.replace(resultUrl);
    }, 10);
  }
}
/**
 * @description 通过 href.search 转化为 query 对象
 * @param url
 * @returns
 */
function getQuery(url) {
  const query: Recordable = {};
  const vars = url.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (pair[0] && pair[1]) {
      query[pair[0]] = pair[1];
    }
  }
  return query;
}
/**
 * @description 通过 query 转化为 href.search
 * @param query
 * @returns
 */
function formatQuery(query: Recordable) {
  if (!Object.keys(query).length) return '';
  const search: string[] = [];
  for (const key in query) {
    if (Object.prototype.hasOwnProperty.call(query, key)) {
      search.push(key + '=' + query[key]);
    }
  }
  return '?' + search.join('&');
}
